<template>
  <v-app>
    <router-view class="mt-2"></router-view>
    <v-footer padless color="grey lighten-2">
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} — <strong>{{ company }}</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "PublicApp",
  data: () => ({
    //tenantIdSelected: null,
    dropdownMenu: false,
    dropdownImpresoras: false,
    impresoras: [],
    impresoraEtiquetas: "",
  }),
  computed: {
    company() {
      // var c = this.companies.find((e) => e.tenantId == this.tenantId);
      return "Flowercargo";
    },

    empresaUsuario() {
      if (this.user.tipo_usuario == 1) {
        return this.user.empresa;
      }
      if (this.user.tipo_usuario == 4) {
        return "Flowercargo";
      }
    },

    ...mapGetters("access", [
      "getIsLoggedIn",
      "store",
      "purchases",
      "users",
      "admin",
      "dimensionesCajas",
    ]),

    ...mapState("access", ["modules", "idActionsRol"]),

    ...mapState("master", [
      "companies",
      "user",
      "token",
      "overlay",
      "tenantId",
      "drawer",
      "menu",
      "titleToolbar",
      "impresoraId",
    ]),

    drawer: {
      get: function () {
        return this.$store.state.master.drawer;
      },
      set: function () {
        return this.$store.state.master.drawer;
      },
    },
  },
  methods: {
    ...mapActions("master", ["requestApi", "alertNotification", "setDrawer"]),
    ...mapActions("access", ["errorRequest", "getModules"]),
    ...mapMutations("master", [
      "setUrl",
      "setMenu",
      "setDrawer",
      "setImpresora",
    ]),
    ...mapMutations("access", [
      "setLogedIn",
      "setActionsRol",
      "setAvailableModules",
    ]),

    /*setSelectedCompany() {
      localStorage.setItem("tenantId", this.tenantIdSelected);
      this.setTenantId(this.tenantIdSelected);
      this.getModules();
    },*/

    setImpresoraUsuario(impId) {
      this.setUrl("api/set-impresora-usuario");
      this.requestApi({
        method: "post",
        data: {
          IMP_ID: impId,
          user_name: this.user.user_login_id,
        },
      })
        .then((res) => {
          this.cargarImpresoras();
          this.dropdownImpresoras = false;
          this.alertNotification({
            param: { html: "Impresora actualizada " },
          });
        })
        .catch((err) => {
          //console.log(err);
        });
    },

    cargarImpresoras() {
      this.setUrl("api/impresoras");
      this.requestApi({
        method: "post",
        data: {
          token: this.token,
          user_name: this.user.user_login_id,
        },
      })
        .then((res) => {
          //localStorage.setItem("impresoraId", 1);
          this.impresoras = res.data.impresoras;
          if (res.data.impresora_usuario.length > 0) {
            this.impresoraEtiquetas = res.data.impresora_usuario[0].DESCRIPCION;
            this.setImpresora(res.data.impresora_usuario[0].PROC_ID);
          }
          //localStorage.removeItem("token");
          //localStorage.setItem("tenantId", null);
          //localStorage.setItem("user", "");
          //this.setTenantId(null);
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    logout() {
      this.setUrl("api/logout");
      this.requestApi({
        method: "post",
        data: {
          token: this.token,
          user_name: this.user.user_login_id,
          //dataBase: this.tenantId,
          system: "sistema_de_carga",
          comment: "ha cerrado sesión ",
        },
      })
        .then((res) => {
          localStorage.removeItem("token");
          //localStorage.setItem("tenantId", null);
          localStorage.setItem("user", "");
          this.setMenu([]);
          //this.setTenantId(null);
          this.setLogedIn(false);
          this.setActionsRol();
          this.alertNotification({
            param: { html: "Adios " + this.user.name },
          });
          if (!this.loggedIn) this.$router.push("/login");
        })
        .catch((err) => {
          console.log(err);
          let response = err.response;
          this.errorRequest({
            data: {
              datos: response.data.errors,
              status: response.status,
            },
          });
        });
    },
  },
  beforeUpdate() {
    //this.tenantIdSelected = this.tenantId;
    this.setMenu(JSON.parse(localStorage.getItem("menu")));
  },
  mounted() {
    document.title = "Sistema de gestión de carga";
    this.cargarImpresoras();
  },
};
</script>

<style>
.title-icon-application {
  font-size: 11px !important;
}

td,
.v-input--selection-controls .v-radio > .v-label {
  font-size: 0.8rem !important;
}

td.custom-price {
  font-size: 1rem !important;
  font-weight: 600;
}

td {
  height: 25px !important;
}

td.td-custom {
  background: #e2e2e2;
  width: 176px;
}

td.td-head-custom {
  background: #8f8f8f;
  color: #fff;
  font-size: 1rem !important;
}

.input-quotation {
  position: relative;
  bottom: 4px;
  border-bottom: 0;
}

input {
  font-size: 14px;
}

.v-text-field input {
  padding-left: 3px;
}

.v-select.v-input--dense .v-select__selection--comma {
  margin: 8px 4px 0px 0 !important;
}

.theme--light.v-select .v-select__selection--disabled,
.v-select__selection--comma,
.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input {
  font-size: 13px !important;
  color: #333 !important;
}

.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input,
.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 6px 0 0px 0px !important;
  font-size: 13px !important;
  color: #333 !important;
}

.v-list-group {
  width: 100%;
}

.v-list-group__header {
  padding: 0 !important;
}

.menu-drop-down {
  font-size: 12px;
  font-weight: 500;
}

.v-list-group__header__append-icon {
  position: absolute;
  right: 0;
}
</style>
